import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";

function InvoicesSummariesCard({ clean = 0, vat = 0, gross = 0, count = 0 }) {
  return (
    <SoftBox my={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={3}>
          <MiniStatisticsCard
            title={{ text: "Καθαρή Αξία", fontWeight: "medium" }}
            count={clean.toFixed(2)}
            icon={{ color: "info", component: "euro" }}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <MiniStatisticsCard
            title={{ text: "Αξία ΦΠΑ", fontWeight: "medium" }}
            count={vat.toFixed(2)}
            icon={{ color: "info", component: "percent" }}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={3}>
          <MiniStatisticsCard
            title={{ text: "Μεικτή Αξία", fontWeight: "medium" }}
            count={gross.toFixed(2)}
            icon={{ color: "info", component: "currency_exchange" }}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <MiniStatisticsCard
            title={{ text: "Πλήθος", fontWeight: "medium" }}
            count={count}
            icon={{ color: "info", component: "folder" }}
          />
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default InvoicesSummariesCard;
